import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';

import { column } from '../common-utils';
import scheduledImportColTmpl from '../template/scheduled-import-column.pug';

const i18nGlobal = globalContext.require('$/i18n!legacy/global');
const i18nLocal = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/accounts-summary');

const importFreqColumnTmpl = globalContext.require('campaignui/feature/scheduled-import/template/freq-column');
const importLogNameTmpl = globalContext.require('campaignui/feature/scheduled-import/template/import-log-name');
const creatorColumnTmpl = globalContext.require('campaignui/feature/scheduled-import/template/creator-column');
const { importSummaryColDataToTemplate } = globalContext.require('campaignui/feature/scheduled-import/view/shared-column-configs/import-summary-col');

export const importTabColumnsConfig = ({ isForVNext }) => ([
  column({
    name: 'LastImportDateAndTime',
    title: 'ColumnName_LastGoogleImportDateAndTime',
    property: 'LastImportInfo/StartDateTime',
    sortable: true,
    type: 'date',
    i18n: i18nLocal,
    template: ({ value }) => importFreqColumnTmpl({ Freq: value && i18nLocal.formatDate(new Date(value), { datetime: 'full' }) }),
  }),
  column({
    name: 'LastImportName',
    title: 'ColumnName_LastImportName',
    property: 'LastImportInfo',
    sortable: 'LastImportInfo/ImportName',
    type: 'string',
    template: ({ value }) => (value ? importLogNameTmpl({ name: value.ImportName || i18nGlobal.getString('QualityScore_NA') }) : '-'),
    i18n: i18nLocal,
  }),
  column({
    name: 'LastImportCreatedBy',
    title: 'ColumnName_LastImportCreatedBy',
    property: 'LastImportInfo',
    sortable: false,
    type: 'string',
    template: ({ value }) => (value && value.UserName && value.ModifiedAt ? creatorColumnTmpl({
      Creator: value.UserName,
      DateTime: i18nLocal.formatDate(new Date(value.ModifiedAt), { date: 'full' }),
      Time: i18nLocal.formatDate(new Date(value.ModifiedAt), { time: 'medium' }),
    }) : '-'),
    i18n: i18nLocal,
  }),
  column({
    name: 'LastImportTool',
    title: 'ColumnName_LastImportTool',
    helpId: 'Pop_BA_Import_Acct_ImportedFrom',
    property: {
      get({ LastImportInfo }) {
        return LastImportInfo && i18nLocal.getString(`LastImportTool_${LastImportInfo.SessionType === 'BAECloudImport' ? 'MAECloud' : 'WebClient'}`);
      },
      key: ['LastImportInfo/SessionType'],
    },
    sortable: false,
    type: 'string',
    i18n: i18nLocal,
  }),
  column({
    name: 'LastImportScope',
    title: 'ColumnName_LastImportScope',
    helpId: 'Pop_BA_Import_Acct_Level',
    property: {
      get({ LastImportInfo }) {
        return LastImportInfo && i18nLocal.getString(`LastImportScope_${LastImportInfo.EntityIdsSpecified ? 'Specific' : 'All'}`);
      },
      key: ['LastImportInfo/EntityIdsSpecified'],
    },
    sortable: false,
    type: 'string',
    i18n: i18nLocal,
  }),
  column({
    name: 'LastImportSummary',
    title: 'ColumnName_LastImportSummary',
    helpId: 'Pop_BA_Import_Acct_Summary',
    property: 'LastImportInfo',
    sortable: false,
    type: 'string',
    i18n: i18nLocal,
    template: ({ value }) => importSummaryColDataToTemplate(value, i18nLocal, true),
  }),
  column({
    name: 'ScheduledImports',
    title: 'ColumnName_ScheduledImports',
    property: 'Id',
    template: ({ value }) => scheduledImportColTmpl({ i18n: i18nLocal, Id: value, isForVNext }),
    i18n: i18nLocal,
  }),
]);
